import { Scroll } from 'ionic-angular';
import { Component, Input, Output, EventEmitter, ElementRef, SimpleChanges } from '@angular/core';


export class initPositionScrollComponent extends Scroll {
     initPosition:number;
     emitEvent:boolean;
     onScroll = new EventEmitter<number>();

    private element:ElementRef;
    private scrollContent:HTMLElement;
    private handler:()=>void;
    private listenerAttached:boolean = false;

    constructor(el:ElementRef) {
        super(el);
        this.element = el;
    }

    ngOnChanges(changes:SimpleChanges) {
        let initPosition = changes['initPosition'];
        if (initPosition && initPosition.currentValue !== undefined && this.scrollContent) {
            this.scrollContent.scrollTop = initPosition.currentValue;
        }
    }

    ngAfterViewInit() {
        const scrollContent = this.scrollContent = this.element.nativeElement.querySelector('.scroll-content');
        if (this.initPosition !== undefined) {
            scrollContent.scrollTop = this.initPosition;
        }

        if (this.emitEvent && !this.listenerAttached) {
            let onScroll = this.onScroll;
            this.handler = function () {
                onScroll.emit(scrollContent.scrollTop);
            };
            this.listenerAttached = true;
            scrollContent.addEventListener('scroll', this.handler);
        }
    }

    ngOnDestroy() {
        if (this.listenerAttached) {
            this.scrollContent.removeEventListener('scroll', this.handler);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'init-position-scroll',
    template: `
        <ion-scroll scrollY="true" zoom="false" style="height:100%">
            <ng-content></ng-content>
        </ion-scroll>
    `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'initPosition': [{ type: Input },],
'emitEvent': [{ type: Input },],
'onScroll': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
